export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Descripción del anuncio",
    descriptionSub: "Elige si la descripción aparece en la página de reserva directa para cada unidad.",
    visible: "Visible",
    hidden: "Oculta",
    amenitiesTitle: "Servicios incluidos",
    amenitiesSub: "Define qué servicios y amenities se mostrarán para cada unidad en tu motor de reservas.",
    amenitiesCount: "{count} servicio | {count} servicios",
    editAmenitiesTitle: "Editar servicios",
    edit: "Editar",
    imagesTitle: "Imágenes del alojamiento",
    imagesSubtitle: "Sube, ordena y define la imagen principal de cada unidad que aparecerá en tu motor de reservas.",
  },
  reservations: {
    updating: "Actualizando…",
    engineActive: "Motor activo",
    engineInactive: "Motor inactivo",
    engineActiveDesc: "Los huéspedes pueden reservar habitaciones directamente desde tu enlace.",
    engineInactiveDesc: "Las reservas directas están desactivadas para este hotel.",
    statusActive: "Activo",
    statusInactive: "Inactivo",
    roomsAvailable: "Habitaciones disponibles",
    colRoom: "Habitación",
    colCap: "Cap.",
    colActive: "Activa",
    noRooms: "No hay habitaciones configuradas.",
    hotelLabel: "Hotel",
    unitActive: "Activa",
    unitInactive: "Inactiva",
    enableNotice: "Activa las reservas directas para poder gestionar las habitaciones.",
    toastUpdated: "Actualizado.",
    toastUpdateError: "No se pudo actualizar.",
    toastGlobalUpdated: "Estado global actualizado.",
  },
  promotions: {
    title: "Promociones en la reserva directa",
    subtitle: "Controla cuáles se activan, si pueden acumularse y el orden.",
    loading: "Cargando promociones…",
    empty: "No hay promociones configuradas para esta propiedad.",
    dragTitle: "Arrastrar para ordenar",
    switchTitle: "Activa en la reserva directa",
    badgeLabel: "Badge",
    badgePlaceholder: "Ej: -10% / Oferta",
    stackableLabel: "Acumulable",
    tip: "Tip: activa la promoción para aplicarla en la reserva directa y usa “Acumulable” si puede convivir con otras promos.",
    toastLoadError: "No se pudieron cargar las promociones.",
    toastSaved: "Promociones guardadas correctamente.",
    toastSaveError: "No se pudieron guardar las promociones.",
    dateFrom: "Desde {date}",
    dateUntil: "Hasta {date}",
  },
  addons: {
    title: "Ocupación y cargos",
    hint1: "Un solo ajuste por {scope}: reducción por menos huéspedes",
    hintOr: "o",
    hint2: "aumento por huésped extra. No ambos.",
    perRoom: "habitación",
    perAccommodation: "alojamiento",
    loading: "Cargando configuración…",
    emptyHotel: "Este hotel no tiene habitaciones configuradas.",
    thisAccommodation: "Este alojamiento",
    modeReduction: "Reducción",
    modeSurcharge: "Aumento",
    modeNone: "Sin ajuste",
    toastLoadError: "No se pudo cargar la configuración de ocupación.",
    toastSaved: "Ocupación guardada correctamente.",
    toastSaveError: "No se pudo guardar la ocupación.",
  },
};
